import { useTheme } from '@emotion/react';
import { useMediaQuery } from '@material-ui/core';

export const WithBreakpoints = ({
  lg,

  md,
  sm,
  xs,

  lgMd,
  lgMdSm,
  mdSm,
  mdSmXs,
  smXs
}: {
  lg?: React.ReactNode;
  md?: React.ReactNode;
  sm?: React.ReactNode;
  xs?: React.ReactNode;

  lgMd?: React.ReactNode;
  lgMdSm?: React.ReactNode;
  mdSm?: React.ReactNode;
  mdSmXs?: React.ReactNode;
  smXs?: React.ReactNode;
}) => {
  const theme = useTheme();
  const _lg = useMediaQuery(theme.breakpoints.up('lg'));
  const _md = useMediaQuery(theme.breakpoints.up('md'));
  const _sm = useMediaQuery(theme.breakpoints.up('sm'));
  const _xs = useMediaQuery(theme.breakpoints.up('xs'));
  const size =
    [
      {
        size: 'lg',
        value: _lg
      },
      {
        size: 'md',
        value: _md
      },
      {
        size: 'sm',
        value: _sm
      },
      {
        size: 'xs',
        value: _xs
      }
    ].find((x) => x.value)?.size || 'xl';
  return (
    <>
      {size === 'lg' && lg}
      {size === 'md' && md}
      {size === 'sm' && sm}
      {size === 'xs' && xs}

      {(size === 'lg' || size === 'md') && lgMd}
      {(size === 'lg' || size === 'md' || size === 'sm') && lgMdSm}
      {(size === 'md' || size === 'sm') && mdSm}
      {(size === 'md' || size === 'sm' || size === 'xs') && mdSmXs}
      {(size === 'sm' || size === 'xs') && smXs}
    </>
  );
};
